import Vue from 'vue'
import App from './App.vue'
import router from './route'
import store from '../store'
import echarts from 'echarts'
import './components/dialog/dialogManager.js'
import './plugins/element.js'
import './api/index'
import '../assets/css/common.css'
import './components'
import '../assets/theme/index.css'
import '../assets/css/el.app.css'


Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Vue.prototype.globalData = {}

// Vue.prototype.$dialog = {
//   open: (config) => {
//     vue.$store.commit('setDialogConfig', config)
//   },
//   closeAll: () => {
//     vue.$store.commit('closeAllDialog')
//   }
// }
